import { apiFactory } from '../ApiFactory';
import { CreateSubscriptionDto } from './types/create-subscription.dto';
import { CreateSubscriptionResponse } from './types/create-subscription-response.type';
import { OpenSubscriptionDto } from './types/open-subscription.dto';
import { ISubscription } from './types/subscription.type';

const create = async (data: CreateSubscriptionDto) => {
	const response = await (
		await apiFactory.getInstance().getCurseducaPayClient()
	).post<CreateSubscriptionResponse>('/subscriptions', data);

	return response.data;
};

// Public endpoint: the Pix waiting screen loads before login.
const findByReference = async (
	reference: string
): Promise<{ statusId: number }> => {
	const response = await (
		await apiFactory.getInstance().getCurseducaPayClient()
	).get<{ statusId: number }>(`/subscriptions/by-reference/${reference}`);

	return response.data;
};

const open = async (data: OpenSubscriptionDto): Promise<ISubscription> => {
	const response = await (
		await apiFactory.getInstance().getCurseducaPayClient()
	).post<ISubscription>('/subscriptions/open', data);

	return response.data;
};

export const subscriptionsApi = {
	create: {
		key: 'CREATE_SUBSCRIPTIONS',
		fetch: create
	},
	findByReference,
	open
};
